import { view } from '@yola/ws-sdk';

const getElementById = (id, isStatic = false) =>
  isStatic ? view.accessors.getStaticElement(id) : view.accessors.getLiveElement(id);

export default getElementById;
